import SalesOrderViewOpproval from "./SalesOrderListOpproval";

/**
 * Component màn hình danh sách đơn hàng hoàn thành
 * Sử dụng component SalesOrderListOpproval với default filter là DON_HANG_HOAN_THANH
 */
const SalesOrderListCompleted = () => {
  return <SalesOrderViewOpproval defaultOrderStatus="DON_HANG_HOAN_THANH" />;
};

export default SalesOrderListCompleted;
